var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPreebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 34C2 21.0786 2 14.618 5.13166 9.99445C6.42888 8.07926 8.07926 6.42888 9.99445 5.13166C14.618 2 21.0786 2 34 2V2C46.9214 2 53.382 2 58.0055 5.13166C59.9207 6.42888 61.5711 8.07926 62.8683 9.99445C66 14.618 66 21.0786 66 34V34C66 46.9214 66 53.382 62.8683 58.0055C61.5711 59.9207 59.9207 61.5711 58.0055 62.8683C53.382 66 46.9214 66 34 66V66C21.0786 66 14.618 66 9.99445 62.8683C8.07926 61.5711 6.42888 59.9207 5.13166 58.0055C2 53.382 2 46.9214 2 34V34Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iif)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4939 34.2472C56.4939 46.534 46.5336 56.4944 34.2469 56.4944C21.9603 56.4944 12 46.534 12 34.2472C12 21.9604 21.9603 12 34.2469 12C46.5336 12 56.4939 21.9604 56.4939 34.2472Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 6.44772 14.6716 6 15.5 6H52.5C53.3284 6 54 6.44772 54 7V7C54 7.55228 53.3284 8 52.5 8H15.5C14.6716 8 14 7.55228 14 7V7Z",
    fill: "#E4F7F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6919 53.875C62.2777 53.875 61.9419 53.5392 61.9419 53.125V14.625C61.9419 14.2108 62.2777 13.875 62.6919 13.875V13.875C63.1061 13.875 63.4419 14.2108 63.4419 14.625V53.125C63.4419 53.5392 63.1061 53.875 62.6919 53.875V53.875Z",
    fill: "#BDEBEA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56689 53.875C5.35979 53.875 5.19189 53.7071 5.19189 53.5L5.19189 14.25C5.19189 14.0429 5.35979 13.875 5.56689 13.875V13.875C5.774 13.875 5.94189 14.0429 5.94189 14.25L5.94189 53.5C5.94189 53.7071 5.774 53.875 5.56689 53.875V53.875Z",
    fill: "#BDEBEA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4459 20.2031C6.21606 20.2031 6.03274 20.0444 6.04556 19.8522C6.12738 18.625 6.50597 14.4894 7.97626 12.4368C9.58739 10.1877 13.1893 8.35541 13.7084 8.09899C13.751 8.07794 13.7972 8.06829 13.8467 8.06829V8.06829C14.1041 8.06829 14.2323 8.3321 14.0475 8.48204C12.9713 9.35473 10.4745 11.4265 9.13525 12.9222C7.64728 14.584 7.00828 18.7349 6.85502 19.8967C6.83193 20.0717 6.65618 20.2031 6.4459 20.2031V20.2031Z",
    fill: "#E4F7F7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6665 20.707C61.867 20.707 62.027 20.5417 62.0158 20.3415C61.9444 19.0631 61.6141 14.7552 60.3312 12.6171C58.9255 10.2743 55.7828 8.36566 55.3298 8.09855C55.2927 8.07663 55.2523 8.06658 55.2092 8.06658V8.06658C54.9846 8.06658 54.8727 8.34138 55.034 8.49757C55.973 9.40662 58.1515 11.5647 59.32 13.1228C60.6183 14.8538 61.1758 19.1776 61.3095 20.3878C61.3297 20.5702 61.483 20.707 61.6665 20.707V20.707Z",
    fill: "#E4F7F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.165 13.5192C8.11104 13.4986 8.08412 13.4384 8.10587 13.3849C8.21356 13.12 8.53794 12.3607 8.96898 11.7069C9.43377 11.0019 10.1111 10.5708 10.2751 10.473C10.2983 10.4592 10.3264 10.4572 10.3517 10.4669V10.4669C10.4192 10.4926 10.4327 10.5831 10.3759 10.6278C10.1105 10.8367 9.50685 11.3331 9.16442 11.7816C8.79365 12.2672 8.41891 13.1649 8.30078 13.4599C8.2793 13.5135 8.21897 13.5398 8.165 13.5192V13.5192Z",
    fill: "#E4F7F7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8919 13.5192C59.9458 13.4986 59.9728 13.4384 59.951 13.3849C59.8433 13.12 59.5189 12.3607 59.0879 11.7069C58.6231 11.0019 57.9457 10.5708 57.7818 10.473C57.7586 10.4592 57.7305 10.4572 57.7052 10.4669V10.4669C57.6377 10.4926 57.6242 10.5831 57.681 10.6278C57.9464 10.8367 58.55 11.3331 58.8925 11.7816C59.2632 12.2672 59.638 13.1649 59.7561 13.4599C59.7776 13.5135 59.8379 13.5398 59.8919 13.5192V13.5192Z",
    fill: "#E4F7F7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter8_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6.6C20 6.26863 20.4701 6 21.05 6H46.95C47.5299 6 48 6.26863 48 6.6V6.6C48 6.93137 47.5299 7.2 46.95 7.2H21.05C20.4701 7.2 20 6.93137 20 6.6V6.6Z",
    fill: "#E4F7F7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1641 36.3C34.3948 36.3 34.6203 36.2326 34.8121 36.1062C35.0039 35.9798 35.1534 35.8002 35.2417 35.5901C35.33 35.38 35.3531 35.1487 35.3081 34.9256C35.2631 34.7026 35.152 34.4977 34.9889 34.3368C34.8257 34.176 34.6179 34.0665 34.3916 34.0221C34.1654 33.9777 33.9309 34.0005 33.7177 34.0875C33.5046 34.1746 33.3224 34.322 33.1943 34.5111C33.0661 34.7002 32.9977 34.9226 32.9977 35.15C32.9977 35.455 33.1206 35.7475 33.3393 35.9632C33.5581 36.1788 33.8547 36.3 34.1641 36.3ZM39.9961 36.3C40.2268 36.3 40.4523 36.2326 40.6442 36.1062C40.836 35.9798 40.9855 35.8002 41.0737 35.5901C41.162 35.38 41.1851 35.1487 41.1401 34.9256C41.0951 34.7026 40.984 34.4977 40.8209 34.3368C40.6578 34.176 40.4499 34.0665 40.2237 34.0221C39.9974 33.9777 39.7629 34.0005 39.5498 34.0875C39.3366 34.1746 39.1545 34.322 39.0263 34.5111C38.8981 34.7002 38.8297 34.9226 38.8297 35.15C38.8297 35.455 38.9526 35.7475 39.1714 35.9632C39.3901 36.1788 39.6868 36.3 39.9961 36.3ZM34.1641 40.9C34.3948 40.9 34.6203 40.8326 34.8121 40.7062C35.0039 40.5798 35.1534 40.4002 35.2417 40.1901C35.33 39.98 35.3531 39.7487 35.3081 39.5256C35.2631 39.3026 35.152 39.0977 34.9889 38.9368C34.8257 38.776 34.6179 38.6665 34.3916 38.6221C34.1654 38.5777 33.9309 38.6005 33.7177 38.6875C33.5046 38.7746 33.3224 38.922 33.1943 39.1111C33.0661 39.3002 32.9977 39.5226 32.9977 39.75C32.9977 40.055 33.1206 40.3475 33.3393 40.5632C33.5581 40.7788 33.8547 40.9 34.1641 40.9ZM39.9961 40.9C40.2268 40.9 40.4523 40.8326 40.6442 40.7062C40.836 40.5798 40.9855 40.4002 41.0737 40.1901C41.162 39.98 41.1851 39.7487 41.1401 39.5256C41.0951 39.3026 40.984 39.0977 40.8209 38.9368C40.6578 38.776 40.4499 38.6665 40.2237 38.6221C39.9974 38.5777 39.7629 38.6005 39.5498 38.6875C39.3366 38.7746 39.1545 38.922 39.0263 39.1111C38.8981 39.3002 38.8297 39.5226 38.8297 39.75C38.8297 40.055 38.9526 40.3475 39.1714 40.5632C39.3901 40.7788 39.6868 40.9 39.9961 40.9ZM28.332 36.3C28.5627 36.3 28.7882 36.2326 28.9801 36.1062C29.1719 35.9798 29.3214 35.8002 29.4097 35.5901C29.4979 35.38 29.521 35.1487 29.476 34.9256C29.431 34.7026 29.3199 34.4977 29.1568 34.3368C28.9937 34.176 28.7859 34.0665 28.5596 34.0221C28.3333 33.9777 28.0988 34.0005 27.8857 34.0875C27.6725 34.1746 27.4904 34.322 27.3622 34.5111C27.234 34.7002 27.1656 34.9226 27.1656 35.15C27.1656 35.455 27.2885 35.7475 27.5073 35.9632C27.726 36.1788 28.0227 36.3 28.332 36.3ZM42.3289 24.8H41.1625V23.65C41.1625 23.345 41.0396 23.0525 40.8209 22.8368C40.6022 22.6212 40.3055 22.5 39.9961 22.5C39.6868 22.5 39.3901 22.6212 39.1714 22.8368C38.9526 23.0525 38.8297 23.345 38.8297 23.65V24.8H29.4985V23.65C29.4985 23.345 29.3756 23.0525 29.1568 22.8368C28.9381 22.6212 28.6414 22.5 28.332 22.5C28.0227 22.5 27.726 22.6212 27.5073 22.8368C27.2885 23.0525 27.1656 23.345 27.1656 23.65V24.8H25.9992C25.0712 24.8 24.1811 25.1635 23.5249 25.8105C22.8687 26.4575 22.5 27.335 22.5 28.25V42.05C22.5 42.965 22.8687 43.8425 23.5249 44.4895C24.1811 45.1365 25.0712 45.5 25.9992 45.5H42.3289C43.257 45.5 44.147 45.1365 44.8033 44.4895C45.4595 43.8425 45.8282 42.965 45.8282 42.05V28.25C45.8282 27.335 45.4595 26.4575 44.8033 25.8105C44.147 25.1635 43.257 24.8 42.3289 24.8V24.8ZM43.4954 42.05C43.4954 42.355 43.3725 42.6475 43.1537 42.8632C42.935 43.0788 42.6383 43.2 42.3289 43.2H25.9992C25.6899 43.2 25.3932 43.0788 25.1745 42.8632C24.9557 42.6475 24.8328 42.355 24.8328 42.05V31.7H43.4954V42.05ZM43.4954 29.4H24.8328V28.25C24.8328 27.945 24.9557 27.6525 25.1745 27.4368C25.3932 27.2212 25.6899 27.1 25.9992 27.1H42.3289C42.6383 27.1 42.935 27.2212 43.1537 27.4368C43.3725 27.6525 43.4954 27.945 43.4954 28.25V29.4ZM28.332 40.9C28.5627 40.9 28.7882 40.8326 28.9801 40.7062C29.1719 40.5798 29.3214 40.4002 29.4097 40.1901C29.4979 39.98 29.521 39.7487 29.476 39.5256C29.431 39.3026 29.3199 39.0977 29.1568 38.9368C28.9937 38.776 28.7859 38.6665 28.5596 38.6221C28.3333 38.5777 28.0988 38.6005 27.8857 38.6875C27.6725 38.7746 27.4904 38.922 27.3622 39.1111C27.234 39.3002 27.1656 39.5226 27.1656 39.75C27.1656 40.055 27.2885 40.3475 27.5073 40.5632C27.726 40.7788 28.0227 40.9 28.332 40.9Z",
    fill: "#F2F5F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iif",
    x: 10.5,
    y: 11.1047,
    width: 46.9939,
    height: 46.2849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.506209 0 0 0 0 0.537255 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.827451 0 0 0 0 0.819608 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 8,
    y: 0,
    width: 52,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 57.3683,
    y: 9.30139,
    width: 10.6472,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 0.618284,
    y: 9.30139,
    width: 9.89722,
    height: 49.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28681,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 3.24492,
    y: 5.26836,
    width: 13.6899,
    height: 17.7348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 52.1578,
    y: 5.26641,
    width: 12.6586,
    height: 18.2405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 7.0686,
    y: 9.08984,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: 56.6179,
    y: 9.08984,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f",
    x: 16,
    y: 2,
    width: 36,
    height: 9.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 22.5,
    y: 22.5,
    width: 25.3282,
    height: 25.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.658954 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34,
    y1: 2,
    x2: 34.3596,
    y2: 67.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487222,
    stopColor: "#44CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23A5A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 36.5,
    y1: 7.5,
    x2: 36.5,
    y2: 68.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122917,
    stopColor: "#66D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AADB0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreebook);
export default __webpack_public_path__ + "static/media/icon_preebook.8629477c35ea8ff50d994118d173fb08.svg";
export { ForwardRef as ReactComponent };